module.exports = __webpack_public_path__ + "img/legrand.fbe803d3.png";